const n = ["parentNode"];
function l(t, i) {
  if (!t.length)
    return;
  const e = t.join("_");
  return i ? `${i}_${e}` : n.includes(e) ? `reo_form_item_${e}` : e;
}
export {
  l as getFieldId
};
//# sourceMappingURL=fieldUtils.mjs.map
